import styles from './lib/scss/main.module.scss'
import coloursModule from './lib/scss/variables/colours.module.scss'
import miscModule from './lib/scss/variables/misc.module.scss'

export const colours = coloursModule
export const misc = miscModule

export default styles
